module.exports = __webpack_public_path__ + "img/8.7c64c98a.jpg";